<template>
  <CBox
    :bg="['none', 'var(--colors-light-primary-light-gray)']"
    :minHeight="['auto', 'calc(100vh - 80px)']"
    width="100vw"
    position="sticky"
    pt="10px"
  >
    <OmtGrid pt="40px">
      <OmtRow>
        <OmtTypography
          as="h1-bold"
          mb="40px"
          >Protocolo {{ protocol }}</OmtTypography
        >
      </OmtRow>

      <OmtRow>
        <div class="info-grid">
          <TextTile
            :title="'Assunto'"
            :description="assunto"
          />
          <TextTile
            :title="'Data da solicitação'"
            :description="dataSolicitacao"
          />
          <TextTile
            :title="'Beneficiário'"
            :description="beneficiario"
          />
          <TextTile
            v-if="!isMobile"
            :title="'Código do associado'"
            :description="codigoBeneficiario"
          />
          <div>
            <OmtTypography
              as="p2"
              color="var(--colors-light-primary-gray2)"
            >
              Status
            </OmtTypography>
            <StatusTile
              :label="statusLabel"
              :color="statusColor"
            />
          </div>
        </div>
      </OmtRow>

      <RequestResponseCard
        v-if="isAnalyzingStatus || statusCode === 'A' || statusCode === 'F'"
        :description="requestDescription"
        :createdAt="dataSolicitacao"
        :pictures="pictures"
        :responses="omintResponses"
        :isOmintRequest="isOmintRequest"
      >
        <template #additional-content>
          <div
            v-if="hasPendency && statusCode !== 'F' && detail.pendency && detail.pendency.days > 0"
            class="cancellation-warning"
          >
            <div class="warning-header">
              <div class="warning-icon">!</div>
              <OmtTypography as="h3-bold">Motivo:</OmtTypography>
            </div>

            <OmtTypography
              as="p1"
              mt="8px"
            >
              {{ detail.pendency.observation || "Procedimentos não descritos" }}
            </OmtTypography>

            <div class="divider" />

            <OmtTypography as="p2">
              <strong>Responda em até {{ detail.pendency.days }} dias</strong>
              ou a solicitação será cancelada.
            </OmtTypography>
          </div>
        </template>
      </RequestResponseCard>

      <OmtRow
        v-if="hasPendency"
        mt="32px"
        flex-direction="column"
      >
        <CBox
          bg="#F6F6F9"
          border-radius="8px"
          p="20px"
          w="100%"
        >
          <CFlex
            align="flex-start"
            style="gap: 14px"
          >
            <img
              :src="IconOmint"
              alt="Omint"
              style="height: 24px; width: 24px; max-width: 24px"
            />
            <CBox>
              <OmtTypography
                as="h3-bold"
                font-size="md"
                color="var(--colors-light-primary-dark-blue)"
                mb="12px"
              >
                Para continuidade da análise, solicitamos:
              </OmtTypography>

              <ul class="pendency-list">
                <li
                  v-for="(reason, i) in pendencyReasons"
                  :key="'reason-' + i"
                >
                  <OmtTypography
                    as="p1"
                    color="var(--colors-light-primary-gray1)"
                  >
                    {{ reason }}
                  </OmtTypography>
                </li>
              </ul>
            </CBox>
          </CFlex>
        </CBox>

        <CBox
          text-align="center"
          mb="40px"
          w="100%"
        >
          <OmtButton
            height="40px"
            fontSize="14px"
            mt="20px"
            width="100%"
            @click="modalPendencies = true"
          >
            Responder pendências
          </OmtButton>
        </CBox>
      </OmtRow>

      <PendingResponseModal
        :reasons="pendencyReasons"
        :isOpen="modalPendencies"
        @close="closeModal"
        @submit="submit"
      />
      <SendPendency
        :isOpen="openModalSuccess"
        :protocol="protocolPendency"
        origin="Programas de Saúde"
        @close="closeModalSendPendency"
      />

      <Footer />
    </OmtGrid>
  </CBox>
</template>

<script>
import Footer from "@/components/Molecules/Footer";
import ImagePreviewer from "@/components/Molecules/ImagePreviewer";
import TextTile from "@/components/Molecules/TextTile";
import StatusTile from "@/components/Organisms/Requests/StatusTile.vue";
import PendingResponseModal from "@/components/Organisms/Sac/PendingResponseModal.vue";
import SendPendency from "@/components/Organisms/Sac/SendPendency.vue";
import RequestResponseCard from "@/components/Organisms/Sac/RequestResponseCard.vue";
import { mapActions } from "vuex";
import { isMobile } from "@/utils/utils";

export default {
  name: "DetailProgramasSaude",
  components: {
    TextTile,
    StatusTile,
    Footer,
    PendingResponseModal,
    SendPendency,
    ImagePreviewer,
    RequestResponseCard
  },
  data() {
    return {
      detail: {},
      modalPendencies: false,
      openModalSuccess: false,
      protocolPendency: 0,
      sending: false,
      pictures: []
    };
  },
  computed: {
    protocol() {
      return this.$route.params.protocol || "";
    },

    assunto() {
      const d = this.detail || {};
      return d.TipoSolicitacao || "";
    },

    dataSolicitacao() {
      const d = this.detail || {};
      return d.DtSolicitacao || "";
    },

    beneficiario() {
      const d = this.detail || {};
      return d.DsUtilizacao || "";
    },

    codigoBeneficiario() {
      const d = this.detail || {};
      return d.CdUtilizacao || "";
    },

    statusLabel() {
      const d = this.detail || {};
      return d.DsSituacao || "";
    },

    statusCode() {
      const d = this.detail || {};
      return d.CdSituacao || "";
    },

    statusColor() {
      const code = this.statusCode || "";
      switch (code) {
        case "F":
          return "var(--colors-light-support-success)";
        case "P":
          return "var(--colors-light-support-warning)";
        case "T":
          return "var(--colors-light-primary-gray2)";
        default:
          return "var(--colors-light-primary-dark-blue)";
      }
    },

    hasPendency() {
      const d = this.detail || {};
      const p = d.Pendencia || d.Pendencias || d.pendency || null;
      if (!p) return false;

      if (d.Pendencia) {
        const pend = d.Pendencia;
        return (Array.isArray(pend.Motivos) && pend.Motivos.length > 0) || !!pend.Observacao;
      }

      if (Array.isArray(d.Pendencias)) {
        return d.Pendencias.length > 0;
      }

      return Boolean(p);
    },

    pendencyReasons() {
      const d = this.detail || {};
      if (d.Pendencia && Array.isArray(d.Pendencia.Motivos)) return d.Pendencia.Motivos;
      if (Array.isArray(d.Pendencias)) return d.Pendencias.map(p => p.Ocorrencia || p.Observacao || p);
      if (d.Pendencia && d.Pendencia.Observacao) return [d.Pendencia.Observacao];
      if (d.pendency && Array.isArray(d.pendency.reasons)) return d.pendency.reasons;
      return [];
    },

    IconOmint() {
      return process.env.VUE_APP_BASE_URL + "images/Group3305.png";
    },

    requestDescription() {
      const d = this.detail || {};
      return d.Descricao || "Sem descrição informada";
    },

    omintResponses() {
      const d = this.detail || {};
      const raw = d.doc?.resp || d.resp || d.Documento.Resposta || d.DsResposta;

      if (!raw) return [];
      let arr = Array.isArray(raw) ? raw : [raw];
      arr = arr.filter(r => {
        // Se for objeto com Resposta
        if (r && r.Resposta) {
          return r.Resposta.trim().length > 0;
        }
        // Se for string
        if (typeof r === "string") {
          return r.trim().length > 0;
        }
        return false;
      });

      // Se for Omint, retorna apenas a primeira resposta
      if (this.isOmintRequest && arr.length > 0) {
        const sorted = [...arr].sort((a, b) => {
          const dateA = this._parseDateTime(a.DataResposta, a.HoraResposta);
          const dateB = this._parseDateTime(b.DataResposta, b.HoraResposta);
          return dateA - dateB;
        });
        return [sorted[0]];
      }

      return arr;
    },

    isAnalyzingStatus() {
      return this.statusLabel === "Em análise" || (this.detail && this.detail.DsSituacao === "Em análise");
    },

    isOmintRequest() {
      const d = this.detail || {};
      return !!(d.DetalheProtocolo || d.AbertoPorOmint);
    },

    isMobile() {
      return isMobile();
    }
  },
  methods: {
    ...mapActions("programasSaude", ["fetchDetalheProtocolo", "enviarRetornoPendencia", "fetchProtocolDetailImage"]),

    async loadPictures() {
      const images = this.detail?.Imagens;
      if (!Array.isArray(images) || images.length === 0) {
        this.pictures = [];
        return;
      }
      this.pictures = [];
      for (const imageId of images) {
        const source = await this.fetchProtocolDetailImage({ documento: imageId, original: false });
        this.pictures.push({ id: imageId, source, loadModalImage: () => this.loadPicture(imageId) });
      }
    },

    async loadPicture(id) {
      return await this.fetchProtocolDetailImage({ documento: id, original: true });
    },

    async getDetail() {
      const response = await this.fetchDetalheProtocolo({ protocolo: this.protocol });
      if (!response) {
        this.$router.replace("/programas-saude");
        return;
      }
      this.detail = response.Data ? response.Data : response;
      if (!this.detail) this.detail = {};
      await this.loadPictures();
    },

    // Parse data e hora para milissegundos
    _parseDateTime(dateStr, timeStr) {
      if (!dateStr || typeof dateStr !== "string") return 0;
      const parts = dateStr.split("/");
      if (parts.length !== 3) return 0;

      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);

      let hour = 0;
      let minute = 0;

      if (timeStr && typeof timeStr === "string") {
        const timeParts = timeStr.split(":");
        if (timeParts.length >= 2) {
          hour = parseInt(timeParts[0], 10);
          minute = parseInt(timeParts[1], 10);
        }
      }

      return new Date(year, month, day, hour, minute).getTime();
    },

    closeModal() {
      this.modalPendencies = false;
    },

    closeModalSendPendency() {
      this.openModalSuccess = false;
      this.protocolPendency = 0;
      this.$router.push("/programas-saude");
    },
    _filesFromPictures(pictures) {
      if (!Array.isArray(pictures)) return [];
      return pictures.map(p => p.file || p).filter(f => f instanceof File);
    },

    async submit({ pictures, obs }) {
      if (!this.hasPendency || this.sending) return;

      const arquivos = (pictures || [])
        .map(p => p.source || p)
        .filter(item => typeof item === "string")
        .slice(0, 20);

      if (!obs?.trim() && arquivos.length === 0) {
        this.$toast({
          description: "Inclua uma observação ou pelo menos um anexo para responder à pendência.",
          status: "warning",
          duration: 7000,
          position: "top"
        });
        return;
      }

      this.sending = true;
      try {
        this.$root.$emit("show-loading");
        const resp = await this.enviarRetornoPendencia({
          protocolo: this.protocol,
          observacao: obs?.slice(0, 350) || "",
          anexo: arquivos
        });

        if (resp && (resp.Data || resp === true)) {
          this.protocolPendency = resp.Data.ProtocoloANS;
          this.modalPendencies = false;
          this.openModalSuccess = true;

          await this.getDetail();
        } else {
          await this.$toast({
            description: "Não foi possível registrar o atendimento. Serviço temporariamente indisponível.",
            status: "error",
            duration: 10000,
            position: "top"
          });
        }
      } catch (err) {
        console.error(err);
        await this.$toast({
          description: "Não foi possível registrar o atendimento. Serviço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      } finally {
        this.$root.$emit("hide-loading");
        this.sending = false;
      }
    }
  },

  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.getDetail();
    } catch (error) {
      console.error(error);
    } finally {
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
.info-grid {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 16px;
}
@media (min-width: 768px) {
  .info-grid {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 120px;
  }
}

.pendency-list {
  list-style-type: decimal;
  padding-left: 20px;
  margin: 0;
  line-height: 1.5;
}
.pendency-list li {
  margin-bottom: 6px;
}

.cancellation-warning {
  margin-top: 20px;
  padding: 16px;
  border-radius: 8px;
  background: #fafafb;
  border: 1px solid #e1e1e6;
}

.warning-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.warning-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #6b6b76;
  color: #6b6b76;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  margin-right: 8px;
}

.divider {
  margin: 12px 0;
  height: 1px;
  background: #e1e1e6;
}
</style>
